if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".lightbox-trigger").forEach(button => {
        button.addEventListener("click", function () {
            let mediaId = this.getAttribute("data-media-id");
            let modal = document.querySelector(".product-media-modal"); // Select the modal dynamically

            if (!modal) {
                console.error("Modal element not found in the DOM.");
                return;
            }

            let modalContent = modal.querySelector(".product-media-modal__content");
            if (!modalContent) {
                console.error("Modal content container not found.");
                return;
            }

            // Clear previous content
            modalContent.innerHTML = "";

            // Create new image element
            let img = document.createElement("img");
            img.src = this.querySelector("img").src; // Get the clicked image source
            img.alt = this.querySelector("img").alt;

            modalContent.appendChild(img);
            modal.classList.add("active"); // Show the modal
        });
    });
});
